const accordianVideoHeading = document.querySelectorAll(
  ".video-accordian .video-accordian-button",
)

accordianVideoHeading.forEach((anchor) => {
  anchor.addEventListener("click", function (event) {
    event.preventDefault()

    // Toggle the 'accordian-active' class on the parent of the parent element of the clicked anchor
    //this.parentElement.parentElement.classList.toggle('accordian-active');

    // Find the closest '.main-video-blocks' element and toggle its 'active' class
    const mainVideoBlocks = this.closest(".main-video-blocks")
    const mainVideoSliders = this.closest(".multiple-video-massages")
    mainVideoBlocks.classList.toggle("active")
    mainVideoSliders.classList.toggle("hide-dots-custom")

    const $section = $(this.closest(".percussive-massage"))
    const sectionHeading = $(".section_heading", $section).text().trim()
    const linkText = $(".sub-heading", $section).text().trim()
    dataLayer.push({
      event: "content_click",
      module_name: sectionHeading,
      link_text:
        linkText +
        (mainVideoBlocks.classList.contains("active") ? " - Open" : " - Close"),
      page_location: window.location.href,
    })
  })
})
